import AxiosClient from "../../../services/axios.services";

class MetricJobExperienceServices {
  getMetricJobExperience = (params) =>
    AxiosClient.get("api/app/capacitacion_metrica_experiencia_puesto/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveMetricJobExperience = (data) =>
    AxiosClient.post("api/app/capacitacion_metrica_experiencia_puesto/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editMetricJobExperience = (id, data) =>
    AxiosClient.put(
      `api/app/capacitacion_metrica_experiencia_puesto/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteMetricJobExperience = (id) =>
    AxiosClient.delete(
      `api/app/capacitacion_metrica_experiencia_puesto/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new MetricJobExperienceServices();
